import React, { useEffect, useMemo } from "react";
import { TextField } from "@mui/material";
import TableFilter from "components/Shared/AppTable/TableFilter";
import BaseAutocomplete from "components/Shared/Base/BaseAutocomplete";
import { useLazyGetActiveBranchListQuery } from "store/services/branchApi";
import { useCustomParams } from "hooks/useCustomParams";
import { useAuth } from "hooks";

const BranchTallyFilter = () => {
  const { params, appendParams, resetParams } = useCustomParams();
  const { fromDate = "", toDate = "", branch = "" } = params;
  const { viewEntity } = useAuth();

  const entity = viewEntity?.entity?._id;

  const [
    fetchBranches,
    {
      data: branchResponse,
      isLoading: loadingBranch,
      isFetching: fetchingBranch,
    },
  ] = useLazyGetActiveBranchListQuery();

  // Normalize the response into an array regardless of API shape
  const branchList = useMemo(() => {
    if (!branchResponse) return [];
    if (Array.isArray(branchResponse)) return branchResponse;
    // Handle common paginated/structured responses:
    if (Array.isArray(branchResponse?.data)) return branchResponse.data;
    if (Array.isArray(branchResponse?.items)) return branchResponse.items;
    if (Array.isArray(branchResponse?.results)) return branchResponse.results;
    if (Array.isArray(branchResponse?.branches)) return branchResponse.branches;
    return [];
  }, [branchResponse]);

  const selectedBranch = branchList.find((b) => b._id === branch) || null;

  useEffect(() => {
    if (!entity) return;
    fetchBranches({ entity, limit: 1000 });
  }, [fetchBranches, entity]);

  return (
    <TableFilter searchLabel="" initialFilters={1} onClear={() => resetParams()}>
      <BaseAutocomplete
        fullWidth
        label="Branch"
        loading={loadingBranch || fetchingBranch}
        loadingText="Loading Branch..."
        options={branchList}
        getOptionLabel={(opt) => (opt ? `${opt?.name} - ${opt?.code}` : "")}
        isOptionEqualToValue={(option, value) => option?._id === value?._id}
        value={selectedBranch}
        onChange={(_, data) => appendParams({ branch: data?._id || "" })}
      />
      <TextField
        fullWidth
        size="small"
        label="From Date"
        type="date"
        InputLabelProps={{ shrink: true }}
        value={fromDate}
        onChange={(e) => appendParams({ fromDate: e.target.value })}
      />
      <TextField
        fullWidth
        size="small"
        label="To Date"
        type="date"
        InputLabelProps={{ shrink: true }}
        value={toDate}
        onChange={(e) => appendParams({ toDate: e.target.value })}
      />
    </TableFilter>
  );
};

export default BranchTallyFilter;